(function () {
    var section = document.querySelector('.faq-section');
    if (!section) return;

    section.addEventListener('click', function (e) {
    var head = e.target.closest('.custom-accordion-head');
    if (!head) return;

    var accordion = head.closest('.custom-accordion');
    var body = accordion.querySelector('.custom-accordin-body');

    if (accordion.classList.contains('is-open')) {
        accordion.classList.remove('is-open');
        body.style.maxHeight = '0px';
    } else {
        accordion.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
    }
    });
})();